module.exports = __webpack_public_path__ + "media/assets/images/task_arrow-fcbe4a1598323c555dd64a81ccf98cbe.png";